import { repository, baseURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/military/findAll')
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/military', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/military', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/military/' + id)
  }
}